import 'core-js/stable';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'slick-carousel';
import 'parsleyjs';
import 'masonry-layout';
import 'focus-visible';
import './components/primary-nav';
import './components/to-top';
import Social from './components/social-widget';
import GraphQL from './components/graphql';
import Header from './components/header';
import Navigation from './components/navigation';
import Sliders from './components/sliders';

import HomePage from './pages/page-home';
import ArchivePage from './pages/page-archive';
import ProductDetailPage from './pages/page-product-detail';
import GarbageBagSelector from './pages/page-garbage-bag-selector';
import ContactUsPage from './pages/page-contact-us';
import OceanRecycledPage from './pages/page-ocean-recycled';

new Header();
new Navigation();
new Sliders();
window.social = new Social();
window.graphql = new GraphQL();

/**
 * Run JS file based on body's class list ( more accurate than pages' slugs).
 */
const bodyClassList = document.body.classList;

// Homepage.
if (bodyClassList.contains('home')) {
    new HomePage();

    // Products, Tips and Tricks, Protection Pointers and Recipes Archive Pages.
} else if (
    bodyClassList.contains('post-type-archive-product_family') ||
    bodyClassList.contains('page-template-page-tips-tricks') ||
    bodyClassList.contains('page-template-archive-ccl_tip') ||
    bodyClassList.contains('page-template-archive-recipe')
) {
    new ArchivePage();

    // Garbage Bag Selector and Food Bag Selector
} else if (
    bodyClassList.contains('page-template-page-garbage-bag-selector') ||
    bodyClassList.contains('page-template-page-food-bag-selector')
) {
    new GarbageBagSelector();

    // Product Detail Page (PDP).
} else if (bodyClassList.contains('ccl_product-template-default')) {
    new ProductDetailPage();

    // Contact Us Page.
} else if (bodyClassList.contains('page-template-page-contact-us')) {
    new ContactUsPage();

    // Ocean Recycled Page.
} else if (bodyClassList.contains('page-template-page-ocean-recycled')) {
    new OceanRecycledPage();
}
